import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';
import type { DebugPanelProps } from './DebugPanel';

const DebugPanel = lazy(() => import('./DebugPanel'));

const DebugPanelPage = wrapLazyNavigatorScreen(
  (props: DebugPanelProps) => {
    return <DebugPanel {...props} />;
  },
  {
    title: 'Debug Panel',
    cardStyle: {
      flex: 1,
      backgroundColor: '#000',
    },
  },
);

export default DebugPanelPage;
